import { createSelector } from '@ngrx/store';
import { appSelector } from '../state/state.selector';
import { ICheckIn } from 'src/app/models/check-in';

export const checkInSelector = createSelector(appSelector, (state) => state.checkIn);
export const checkInDataSelector = createSelector(checkInSelector, (state: ICheckIn) => {
  return state;
});


export const proxyCheckInSelector = createSelector(appSelector, (state) => state.proxyCheckIn);
export const checkInArrayDataSelector = createSelector(proxyCheckInSelector, (state: ICheckIn[]) => {
  return state;
});

export const proxyGroupCheckInSelector = createSelector(appSelector, (state) => state.proxyGroupCheckIn);




